import Cookies from "js-cookie";
import React, { useEffect, useState } from "react";
import { IntlProvider } from "react-intl";
import { useDispatch, useSelector } from "react-redux";

import { defaultLocale } from "../config/locales.js";
import { selectLocale } from "../store/selectors.js";
import { setLocale } from "../store/sessionSlice.js";
import nlMessages from "../translations/nl.json";

const messages = {
  nl: nlMessages,
};

const loadIntlPolyfills = async () => {
  if (typeof Intl !== "undefined") {
    await import("@formatjs/intl-pluralrules/polyfill");
    await import("@formatjs/intl-relativetimeformat/polyfill");
  }
};

const ConnectedIntlProvider = ({ children }) => {
  const locale = useSelector(selectLocale);
  const dispatch = useDispatch();

  const [isPolyfillsLoaded, setPolyfillsLoaded] = useState(false);

  useEffect(() => {
    const cookieLocale = Cookies.get("locale_cookie");
    if (cookieLocale) {
      dispatch(setLocale(cookieLocale));
    }
    loadIntlPolyfills().then(() => setPolyfillsLoaded(true));
  }, []);

  if (!isPolyfillsLoaded) {
    return <div>Loading...</div>;
  }

  return (
    <IntlProvider
      key={locale}
      locale={locale}
      defaultLocale={defaultLocale}
      messages={messages[locale]}
    >
      {children}
    </IntlProvider>
  );
};

export default ConnectedIntlProvider;
